import React from 'react';
import Box from '@mui/material/Box';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { S3_BUCKET } from '../../constants';
import { ModalLayout } from './BigModalLayout';
import { StyledChooseImageStack } from './styles/ChooseImageStyles';

export function ChooseImage({ showModal, closeModal, defaultImages, updateImage }) {
    return <ModalLayout open={showModal}
        title="Choose one of ours"
        setOpen={closeModal}>
        <StyledChooseImageStack>
            {
                defaultImages?.map((image, index) => {
                    return <Box className="ImageContainer" key={index}>
                        <LazyLoadImage
                            src={S3_BUCKET + "medium/" + image.path} // use normal <img> attributes as props
                            effect="blur"
                            onClick={() => updateImage({ path: image.path, default: true, file: null })}
                            onError={(e) => { e.target.onerror = null; e.target.src = S3_BUCKET + 'medium/fundraiser-pages/September2020/fc-128-1599224373.jpg' }}
                        />
                    </Box>
                })
            }
        </StyledChooseImageStack>
    </ModalLayout>
}